import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// In-memory access token (not persisted to localStorage to avoid XSS token theft).
// The httpOnly cookies set by the backend restore the session across reloads via /auth/me.
let accessToken = null;
export const setAccessToken = (token) => {
  accessToken = token || null;
};

api.interceptors.request.use((config) => {
  if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
  return config;
});

export function formatApiError(detail, fallback = "Une erreur est survenue. Réessayez.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
